import React, { useState } from "react";
import { Alert } from "@material-ui/lab";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import Notification from "../../../elements/notification/Notification";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { StyledCopy } from "../../../styles/styledCopy";
import RenderStatus from "../../../styles/styledStatus";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const ExchangeHistoryList = ({ exchangeHistory }) => {
  const { t } = useTranslation("exchangerPage");

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  if (!exchangeHistory) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (exchangeHistory.length === 0) {
    return <Alert severity="warning">{t("history.table.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledScrollTable className="exchange-table_scroll">
        <StyledTable
          width="1440"
          size="14"
          className="exchange-table"
        >
          <StyledTableHead
            scroll="auto"
            col="7"
            className="exchange-table__head"
          >
            <div>
              {t("history.table.id")}
            </div>
            <div>
              {t("history.table.inService")}
            </div>
            <div>
              {t("history.table.inAmount")}
            </div>
            <div>
              {t("history.table.outService")}
            </div>
            <div>
              {t("history.table.outAmount")}
            </div>
            <div>
              {t("history.table.status")}
            </div>
            <div>
              {t("history.table.date")}
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {exchangeHistory.map((item, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="7"
                className="exchange-table__row"
              >
                <StyledCol
                  data-title={t("history.table.id")}
                >
                  <CopyToClipboard
                    text={item.id}
                    onCopy={() => {
                      setNotification({ ...notification, visible: true, type: "success", message: t("history.table.copied") });
                    }}
                  >
                    <StyledBreakWord as="p">
                      {item.id} <StyledCopy title={t("history.table.copy")} className="icon-light-copy" />
                    </StyledBreakWord>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol
                  data-title={t("history.table.inService")}
                >
                  {item.pair?.exchangePair?.inService?.name || "--"}
                </StyledCol>
                <StyledCol
                  inline
                  data-title={t("history.table.inAmount")}
                >
                  <StyledBreakWord as="p">
                    {item.inAmount} {item.pair?.exchangePair?.inCurrency?.asset}
                  </StyledBreakWord>
                </StyledCol>
                <StyledCol
                  data-title={t("history.table.outService")}
                >
                  {item.pair?.exchangePair?.outService?.name || "--"}
                </StyledCol>
                <StyledCol
                  inline
                  data-title={t("history.table.outAmount")}
                >
                  <StyledBreakWord as="p">
                    {item.outAmount} {item.pair?.exchangePair?.outCurrency?.asset}
                  </StyledBreakWord>
                </StyledCol>
                <StyledCol
                  inline
                  data-title={t("history.table.status")}
                >
                  <RenderStatus status={item.status?.value} />
                </StyledCol>
                <StyledCol
                  data-title={t("history.table.date")}
                >
                  {TimestampToDateMoment(item.createdAt)}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default ExchangeHistoryList;